import flag1 from "../../../assets/flags/building-outdoor-facade-flag.jpeg";
import flag2 from "../../../assets/flags/ceremonial-floor-standing-flagpoles.png";
import flag3 from "../../../assets/flags/tabel-vip-flag.png";
import flag4 from "../../../assets/flags/car-flagpole.svg";
import flag5 from "../../../assets/flags/advertising-flag.svg";
import flag6 from "../../../assets/flags/ceremonial-indoor-standing-flagpole.png";
import flag7 from "../../../assets/flags/cairo-flagpole-egypt-new-administrative-capital-aerial.png";
import flag8 from "../../../assets/flagpoles/vip-gold-indoor-flagpole-desk-flag.png";

import lanyard1 from "../../../assets/lanyards/premium-leather-lanyard-id-badge-closeup.png";
import lanyard2 from "../../../assets/lanyards/branded-corporate-sublimation-lanyards-collection.png";
import lanyard3 from "../../../assets/lanyards/lanyard.png";
import lanyard4 from "../../../assets/lanyards/black-lanyard-id-card-badge-holder.jpg";

import Banner1 from "../../../assets/banners/custom-outdoor-barrier-banner-uae.mp4";
import Banner2 from "../../../assets/banners/custom-printed-banner-display.svg";
import Banner3 from "../../../assets/banners/custom-school-fence-banner.svg";
import Banner4 from "../../../assets/banners/pop-up-display-banner.svg";
import Banner6 from "../../../assets/banners/uae-national-day-rollup-banner.jpg";
import Banner5 from "../../../assets/banners/outdoor-billboard-branding-uae.jpg";
import Banner7 from "../../../assets/banners/fence-mesh-banner-outdoor.svg";
import Banner8 from "../../../assets/banners/crowd-barrier-banner-custom.svg";

import badge1 from "../../../assets/badges/uae-flag-day-magnetic-enamel-badge.png";
import badge2 from "../../../assets/badges/uae-union-day-embroidered-patches.png";
import badge3 from "../../../assets/badges/crossed-flag-lapel-pins-uae-gcc.png";

import sticker1 from "../../../assets/stickers/heat-area-signage-sticker.svg";
import sticker3 from "../../../assets/stickers/cutting-area-signage-sticker.svg";
import sticker4 from "../../../assets/stickers/large-format-sticker-printer-factory.png";
import sticker5 from "../../../assets/stickers/glass-door-safety-sticker-restricted-area.svg";
import sticker6 from "../../../assets/stickers/custom-window-decals.svg";
import sticker7 from "../../../assets/stickers/custom-vehicle-wrap-car-branding.png";
import sticker8 from "../../../assets/stickers/on-building-facade-sticker.png";
import sticker9 from "../../../assets/stickers/one-way-vision-sticker-on-building.png";
import sticker10 from "../../../assets/stickers/high-rise-sticker-installation-team.png";

import apparel1 from "../../../assets/apparels/custom-reflective-safety-vests-uae.png";
import apparel2 from "../../../assets/apparels/custom-sublimation-football-jerseys.png";
import apparel3 from "../../../assets/apparels/uae-national-day-graduation-sashes.png";
import apparel4 from "../../../assets/apparels/formal-corporate-dress-shirt-uae.png";
import apparel5 from "../../../assets/apparels/custom-printed-event-sash-arabic.png";
import apparel6 from "../../../assets/apparels/takatof-volunteer-vest-reflective-uae.png";
import apparel7 from "../../../assets/apparels/uae-1971-commemorative-scarf.png";

import flagpole1 from "../../../assets/flagpoles/aluminum-manual-internal-halyard-flag-pole-white-powder-coated.svg";
import flagpole2 from "../../../assets/flagpoles/aluminum-outdoor-flagpole-technical-diagram.svg";
import flagpole3 from "../../../assets/videos/custom-table-flags-with-gold-stands.mp4";
import flagpole4 from "../../../assets/flagpoles/indoor-flagpole-gold-chrome-ornate.png";
import flagpole5 from "../../../assets/flagpoles/indoor-flagpole-gold-chrome-ball-finial.png";
import flagpole6 from "../../../assets/flagpoles/indoor-flagpole-gold-chrome-globe-spear.png";
import flagpole7 from "../../../assets/flagpoles/indoor-flagpole-gold-chrome-slim.png";
import flagpole8 from "../../../assets/flagpoles/l-shape-flagpoles-landscape.png";
import flagpole9 from "../../../assets/flagpoles/fiberglass-outdoor-flagpole-6-meter.svg";
import flagpole10 from "../../../assets/flagpoles/rooftop-flagpole-building-mount.svg";
import flagpole11 from "../../../assets/flagpoles/wall-mounted-flagpole-building.jpg";

import {
  CategoryCardData,
  CategoryNode,
  MediaItem,
} from "../../../types/RandomGlobalTypes";

type CategoryGroup = {
  titleKey: string;
  itemKeys: string[];
};

export type ServiceDetailType = {
  slug: string;
  titleKey: string;
  subtitleKey: string;
  descriptionKey?: string;
  heroBadgeKey?: string;
  media: MediaItem[];
  featuresKeys?: string[];
  specs?: Record<string, string>;
  processKeys?: string[];
  faq?: Array<{ qKey: string; aKey: string }>;
  categoriesKeys?: string[];
  categoryGroups?: CategoryGroup[];
  categoryCards?: CategoryCardData[];
  typesTree?: Record<string, CategoryNode>; // hierarchical modes (B/C)
  ctaHref?: string;
  ctaLabelKey?: string;
  tagsKeys?: string[];
  specsIntroKey?: string;
  faqIntroKey?: string;
  relatedServices?: {
    titleKey: string;
    items: Array<{ textKey: string; href: string }>;
  };
};

export const ServiceDetails: ServiceDetailType[] = [
  /* =================== FLAGS (now using typesTree) =================== */
  {
    slug: "custom-flags",
    titleKey: "services:detail:flags:title",
    subtitleKey: "services:detail:flags:subtitle",
    descriptionKey: "services:detail:flags:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",
    tagsKeys: [
      "services:detail:flags:tags:customSizes",
      "services:detail:flags:tags:fireRetardant",
    ],
    media: [{ src: flag8, alt: "tabele flags" }],
    featuresKeys: [
      "services:detail:flags:features:fireRetardant",
      "services:detail:flags:features:ecoFriendly",
      "services:detail:flags:features:windRated",
      "services:detail:flags:features:fastTurn",
    ],

    typesTree: {
      type1: {
        titleKey: "services:detail:flags:types:type1:title",

        cards: [
          {
            titleKey: "services:detail:flags:types:type1:categories:vip:title",
            img: flag2,
            alt: "UAE ceremonial flags on VIP gold and chrome floor-standing flagpoles with fringe detail",
          },
          {
            titleKey:
              "services:detail:flags:types:type1:categories:deluxe:title",
            img: flag6,
            alt: "UAE VIP ceremonial flag on gold floor-standing flagpole with decorative globe finial",
          },
          {
            titleKey:
              "services:detail:flags:types:type1:categories:table:title",
            img: flag3,
            alt: "UAE table desk flags on gold and chrome stands with ornate pointed finials",
          },
        ],
      },

      type2: {
        titleKey: "services:detail:flags:types:type2:title", // Outdoor
        cards: [
          {
            titleKey:
              "services:detail:flags:types:type2:categories:giant:title",
            img: flag7,
            alt: "Giant national flag on record-scale mega flagpole — aerial view of large-scale flag manufacturing project",
          },
          {
            titleKey:
              "services:detail:flags:types:type2:categories:popular:title",
            img: "",
            alt: "",
          },
          {
            titleKey:
              "services:detail:flags:types:type2:categories:marine:title",
            img: "",
            alt: "",
          },
          {
            titleKey: "services:detail:flags:types:type2:categories:car:title",
            img: flag4,
            alt: "Custom car flag on window-mounted flagpole for national day celebrations and events",
          },
          {
            titleKey:
              "services:detail:flags:types:type2:categories:advertising:title",
            img: flag5,
            alt: "Custom advertising feather flag for outdoor promotional events and business branding",
          },
          {
            titleKey:
              "services:detail:flags:types:type2:categories:building:title",
            img: flag1,
            alt: "Giant UAE national flag draped on commercial building facade for national day celebrations",
          },
        ],
      },
    },

    processKeys: [
      "services:detail:process:consult",
      "services:detail:process:proof",
      "services:detail:process:print",
      "services:detail:process:finish",
      "services:detail:process:deliver",
    ],
    faq: [
      {
        qKey: "services:detail:flags:faq:q1",
        aKey: "services:detail:flags:faq:a1",
      },

      {
        qKey: "services:detail:flags:faq:q2",
        aKey: "services:detail:flags:faq:a2",
      },
      {
        qKey: "services:detail:flags:faq:q3",
        aKey: "services:detail:flags:faq:a3",
      },
      {
        qKey: "services:detail:flags:faq:q4",
        aKey: "services:detail:flags:faq:a4",
      },
      {
        qKey: "services:detail:flags:faq:q5",
        aKey: "services:detail:flags:faq:a5",
      },
      {
        qKey: "services:detail:flags:faq:q6",
        aKey: "services:detail:flags:faq:a6",
      },
      {
        qKey: "services:detail:flags:faq:q7",
        aKey: "services:detail:flags:faq:a7",
      },
    ],
    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
  {
    slug: "flagpoles",
    titleKey: "services:detail:flagpoles:title",
    subtitleKey: "services:detail:flagpoles:subtitle",
    descriptionKey: "services:detail:flagpoles:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",
    media: [
      {
        src: flagpole1,
        alt: "White powder-coated aluminum outdoor flagpole with manual internal halyard system — available in 8 to 25 meter heights",
      },
      {
        src: flagpole2,
        alt: "Technical engineering diagram showing aluminum flagpole specifications, base plate dimensions, and halyard mechanism details",
      },
      { type: "video", src: flagpole3 },
    ],
    featuresKeys: [
      "services:detail:flagpoles:features:al6063",
      "services:detail:flagpoles:features:internalHalyard",
      "services:detail:flagpoles:features:ssRope",
      "services:detail:flagpoles:features:powderCoatWhite",
      "services:detail:flagpoles:features:pulley",
      "services:detail:flagpoles:features:basePlate",
      "services:detail:flagpoles:features:anchorCage",
      "services:detail:flagpoles:features:sizes",
    ],
    specs: {
      "services:detail:flagpoles:specs:labels:materials":
        "services:detail:flagpoles:specs:materials",
      "services:detail:flagpoles:specs:labels:halyard":
        "services:detail:flagpoles:specs:halyard",
      "services:detail:flagpoles:specs:labels:rope":
        "services:detail:flagpoles:specs:rope",
      "services:detail:flagpoles:specs:labels:surface":
        "services:detail:flagpoles:specs:surface",
      "services:detail:flagpoles:specs:labels:finial":
        "services:detail:flagpoles:specs:finial",
      "services:detail:flagpoles:specs:labels:counterweight":
        "services:detail:flagpoles:specs:counterweight",
      "services:detail:flagpoles:specs:labels:anchorCage":
        "services:detail:flagpoles:specs:anchorCage",
      "services:detail:flagpoles:specs:labels:basePlate":
        "services:detail:flagpoles:specs:basePlate",
      "services:detail:flagpoles:specs:labels:baseCover":
        "services:detail:flagpoles:specs:baseCover",
      "services:detail:flagpoles:specs:labels:heights":
        "services:detail:flagpoles:specs:heights",
    },

    typesTree: {
      type1: {
        titleKey: "services:detail:flagpoles:types:type1:title",
        introKey: "services:detail:flagpoles:indoorIntro",
        subtypes: {
          table: {
            titleKey:
              "services:detail:flagpoles:types:type1:subtypes:table:title",

            cards: [
              {
                titleKey:
                  "services:detail:flagpoles:types:type1:subtypes:table:categories:vip:title",
                descKey:
                  "services:detail:flagpoles:types:type1:subtypes:table:categories:vip:desc",
                img: flagpole4,
                alt: "VIP gold and chrome indoor table flagpole stands with ornate pointed finials and polished dome bases",
              },
              {
                titleKey:
                  "services:detail:flagpoles:types:type1:subtypes:table:categories:normal:title",
                descKey:
                  "services:detail:flagpoles:types:type1:subtypes:table:categories:normal:desc",
                img: flagpole5,
                alt: "Standard gold and chrome indoor table flagpole stands with ball finials and trumpet bases",
              },
            ],
          },

          office: {
            titleKey:
              "services:detail:flagpoles:types:type1:subtypes:office:title",
            cards: [
              {
                titleKey:
                  "services:detail:flagpoles:types:type1:subtypes:office:categories:vip:title",
                descKey:
                  "services:detail:flagpoles:types:type1:subtypes:office:categories:vip:desc",
                img: flagpole6,
                alt: "VIP gold and chrome floor-standing office flagpole stands with decorative globe spear finials and flat disc bases",
              },
              {
                titleKey:
                  "services:detail:flagpoles:types:type1:subtypes:office:categories:regular:title",
                descKey:
                  "services:detail:flagpoles:types:type1:subtypes:office:categories:regular:desc",
                img: flagpole7,
                alt: "Standard gold and chrome floor-standing office flagpole stands with ball finials and slim round bases",
              },
            ],
          },
        },
      },

      type2: {
        titleKey: "services:detail:flagpoles:types:type2:title",
        introKey: "services:detail:flagpoles:outdoorIntro",
        cards: [
          {
            titleKey:
              "services:detail:flagpoles:types:type2:categories:lShape:title",
            img: flagpole8,
            alt: "Multiple L-shape outdoor flagpoles with UAE national flags illuminated at night along heritage site streetscape",
            descKey:
              "services:detail:flagpoles:types:type2:categories:lShape:description",
          },
          {
            titleKey:
              "services:detail:flagpoles:types:type2:categories:fiberglass6m:title",
            descKey:
              "services:detail:flagpoles:types:type2:categories:fiberglass6m:description",
            img: flagpole9,
            alt: "Fiberglass 6-meter outdoor flagpole with white finish — lightweight and corrosion-resistant for coastal environments",
          },
          {
            titleKey:
              "services:detail:flagpoles:types:type2:categories:aluminumHeights:title",
            descKey:
              "services:detail:flagpoles:types:type2:categories:aluminumHeights:description",
            img: flagpole1,
            alt: "Aluminum outdoor flagpoles available in 8, 10, 15, 21, and 25 meter heights with white powder-coated finish",
          },
          {
            titleKey:
              "services:detail:flagpoles:types:type2:categories:overBuilding:title",

            img: flagpole10,
            alt: "Rooftop-mounted flagpole installation diagram for commercial and government building facades",
          },
          {
            titleKey:
              "services:detail:flagpoles:types:type2:categories:wall45:title",
            descKey:
              "services:detail:flagpoles:types:type2:categories:wall45:description",
            img: flagpole11,
            alt: "45-degree wall-mounted flagpole bracket with UAE flag installed on building exterior facade",
          },
        ],
      },
    },

    specsIntroKey: "services:detail:flagpoles:specsIntro",
    faqIntroKey: "services:detail:flagpoles:faqIntro",
    relatedServices: {
      titleKey: "services:detail:flagpoles:relatedServices:title",
      items: [
        {
          textKey: "services:detail:flagpoles:relatedServices:flags:text",
          href: "/services/custom-flags",
        },
        {
          textKey: "services:detail:flagpoles:relatedServices:banners:text",
          href: "/services/banners",
        },
      ],
    },
    faq: [
      {
        qKey: "services:detail:flagpoles:faq:q1",
        aKey: "services:detail:flagpoles:faq:a1",
      },
      {
        qKey: "services:detail:flagpoles:faq:q2",
        aKey: "services:detail:flagpoles:faq:a2",
      },
      {
        qKey: "services:detail:flagpoles:faq:q3",
        aKey: "services:detail:flagpoles:faq:a3",
      },
      {
        qKey: "services:detail:flagpoles:faq:q4",
        aKey: "services:detail:flagpoles:faq:a4",
      },
      {
        qKey: "services:detail:flagpoles:faq:q5",
        aKey: "services:detail:flagpoles:faq:a5",
      },
    ],
    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
  {
    slug: "apparel",
    titleKey: "services:detail:apparel:title",
    subtitleKey: "services:detail:apparel:subtitle",
    descriptionKey: "services:detail:apparel:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",

    media: [
      // { src: apparel7, alt: "national day scarve" },
      {
        src: apparel5,
        alt: "Custom printed orange event sash with Arabic calligraphy and geometric pattern design",
      },
      {
        src: apparel6,
        alt: "Custom black Takatof volunteer vest with reflective strips, UAE flag patch, and bilingual branding",
      },
      {
        src: apparel7,
        alt: "UAE 1971 commemorative scarf with Arabic typography and heritage design",
      },
    ],

    // no features for apparel
    featuresKeys: [],

    // Categories as cards (uses title keys from en.json + new :desc keys below)

    categoryCards: [
      {
        titleKey: "services:detail:apparel:categories:corporate::title",
        descKey: "services:detail:apparel:categories:corporate:desc",
        img: apparel4,
        alt: "Light blue formal long-sleeve corporate dress shirt with dark trousers for professional uniforms",
      },
      {
        titleKey: "services:detail:apparel:categories:vests::title",
        descKey: "services:detail:apparel:categories:vests:desc",
        img: apparel1,
        alt: "Custom branded reflective safety vests in yellow, black, and gray for volunteer and corporate events",
      },
      {
        titleKey: "services:detail:apparel:categories:scarves:title",
        descKey: "services:detail:apparel:categories:scarves:desc",
        img: apparel3,
        alt: "UAE national day graduation sashes with Arabic calligraphy, UAE emblem, and flag colors",
      },
      {
        titleKey: "services:detail:apparel:categories:sportswear:title",
        descKey: "services:detail:apparel:categories:sportswear:desc",
        img: apparel2,
        alt: "Custom sublimation-printed football jerseys with full-color team crests and numbering",
      },
    ],
    faq: [
      {
        qKey: "services:detail:apparel:faq:q1",
        aKey: "services:detail:apparel:faq:a1",
      },
      {
        qKey: "services:detail:apparel:faq:q2",
        aKey: "services:detail:apparel:faq:a2",
      },
    ],

    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
  {
    slug: "lanyards",
    titleKey: "services:detail:lanyards:title",
    subtitleKey: "services:detail:lanyards:subtitle",
    descriptionKey: "services:detail:lanyards:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",
    media: [
      {
        src: lanyard1,
        alt: "Custom printed lanyards",
      },
      {
        src: lanyard2,
        alt: "Event lanyards with logo printing by Creation Arts",
      },
      { src: lanyard3, alt: "ID card lanyards and accessories" },
      { src: lanyard4, alt: "Branded event lanyards by Creation Arts" },
    ],
    featuresKeys: [],
    processKeys: [
      "services:detail:process:consult",
      "services:detail:process:proof",
      "services:detail:process:print",
      "services:detail:process:deliver",
    ],
    faq: [
      {
        qKey: "services:detail:lanyards:faq:q1",
        aKey: "services:detail:lanyards:faq:a1",
      },
      {
        qKey: "services:detail:lanyards:faq:q2",
        aKey: "services:detail:lanyards:faq:a2",
      },
      {
        qKey: "services:detail:lanyards:faq:q3",
        aKey: "services:detail:lanyards:faq:a3",
      },
    ],
    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },

  {
    slug: "banners",
    titleKey: "services:detail:banners:title",
    subtitleKey: "services:detail:banners:subtitle",
    descriptionKey: "services:detail:banners:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",
    media: [
      {
        src: Banner1,
        alt: "High-quality custom outdoor barrier banner production",
      },
      {
        src: Banner2,
        alt: "Custom printed banner display for events and exhibitions",
      },
      {
        src: Banner3,
        alt: "Custom printed school fence banner for campus branding",
      },
    ],
    categoriesKeys: [
      "services:detail:banners:categories:umbrella",
      "services:detail:banners:categories:blockout",
      "services:detail:banners:categories:mesh",
      "services:detail:banners:categories:fabric",
      "services:detail:banners:categories:rollup",
    ],
    featuresKeys: [
      "services:detail:banners:features:outdoorRated",
      "services:detail:banners:features:photoQuality",
      "services:detail:banners:features:customSizes",
      "services:detail:banners:features:doubleSided",
    ],
    categoryCards: [
      {
        titleKey: "services:detail:banners:categories:umbrella",
        img: Banner4,
        alt: "Pop-up display banner for trade shows and corporate events",
        to: "/gallery?type=umbrella",
      },
      {
        titleKey: "services:detail:banners:categories:hoarding",
        img: Banner5,
        alt: "Large-format outdoor billboard with custom branding in urban cityscape",
        to: "/gallery?type=hoarding",
      },
      {
        titleKey: "services:detail:banners:categories:tint",
        img: Banner6,
        alt: "UAE National Day retractable rollup banner with Abu Dhabi skyline",
        to: "/gallery?type=tint",
      },
      {
        titleKey: "services:detail:banners:categories:fence",
        img: Banner7,
        alt: "Outdoor fence mesh banner for construction sites and perimeter branding",
        to: "/gallery?type=fence",
      },
      {
        titleKey: "services:detail:banners:categories:barrier",
        img: Banner8,
        alt: "Custom printed crowd barrier banner for events and outdoor advertising",
        to: "/gallery?type=barrier",
      },
    ],

    faq: [
      {
        qKey: "services:detail:banners:faq:q1",
        aKey: "services:detail:banners:faq:a1",
      },
      {
        qKey: "services:detail:banners:faq:q2",
        aKey: "services:detail:banners:faq:a2",
      },
    ],
    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
  {
    slug: "badges",
    titleKey: "services:detail:badges:title",
    subtitleKey: "services:detail:badges:subtitle",
    descriptionKey: "services:detail:badges:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",

    media: [
      {
        src: badge1,
        alt: "UAE flag day magnetic enamel badge with gold-plated figures holding the national flag",
      },
      {
        src: badge2,
        alt: "UAE 52nd Union Day embroidered patches with Arabic calligraphy and traditional sadu pattern",
      },
      {
        src: badge3,
        alt: "Gold crossed flag lapel pins featuring UAE paired with Saudi Arabia, Oman, and Bahrain flags",
      },
    ],

    featuresKeys: [
      "services:detail:badges:features:customShapes",
      "services:detail:badges:features:sizeRange",
      "services:detail:badges:features:highQuality",
    ],

    // Short FAQ (2–3 items)
    faq: [
      {
        qKey: "services:detail:badges:faq:q3",
        aKey: "services:detail:badges:faq:a3",
      },
      {
        qKey: "services:detail:badges:faq:q2",
        aKey: "services:detail:badges:faq:a2",
      },
    ],

    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
  {
    slug: "sticker",
    titleKey: "services:detail:sticker:title",
    subtitleKey: "services:detail:sticker:subtitle",
    descriptionKey: "services:detail:sticker:description",
    heroBadgeKey: "services:detail:badgeMadeInUAE",
    media: [
      {
        src: sticker9,
        alt: "One-way vision sticker on commercial building facade",
      },
      { src: sticker10, alt: "High-rise sticker installation team Dubai UAE" },
      { src: sticker6, alt: "Custom window decals for glass storefront" },
      { src: sticker3, alt: "Cutting area safety signage sticker for factory" },
      { src: sticker8, alt: "Outdoor building facade sticker branding UAE" },
      { src: sticker4, alt: "Large format sticker printing machine factory" },
    ],

    featuresKeys: [
      "services:detail:sticker:features:emboss",
      "services:detail:sticker:features:doublePrinting",
    ],

    categoryCards: [
      {
        titleKey: "services:detail:sticker:categories:building",
        img: sticker8,
        alt: "Custom building facade stickers and outdoor branding",
      },
      {
        titleKey: "services:detail:sticker:categories:car",
        img: sticker7,
        alt: "Custom vehicle wrap and car branding stickers",
      },
      {
        titleKey: "services:detail:sticker:categories:glass",
        img: sticker6,
        alt: "Custom window decals and glass door stickers",
      },
      {
        titleKey: "services:detail:sticker:categories:signboard",
        img: sticker1,
        alt: "Heat area warning signage sticker for industrial use",
      },
      {
        titleKey: "services:detail:sticker:categories:wall",
        img: sticker5,
        alt: "Glass door safety sticker restricted area signage",
      },
    ],

    faq: [
      {
        qKey: "services:detail:sticker:faq:q1",
        aKey: "services:detail:sticker:faq:a1",
      },
      {
        qKey: "services:detail:sticker:faq:q2",
        aKey: "services:detail:sticker:faq:a2",
      },
      {
        qKey: "services:detail:sticker:faq:q3",
        aKey: "services:detail:sticker:faq:a3",
      },
    ],

    ctaHref: "/contact",
    ctaLabelKey: "services:detail:cta:getQuote",
  },
];
